<div class="popup_block" style="margin-left: 0">
    <ng-container>
        <div #opener (click)="open = !open" *ngIf="hidden">
            <ng-content></ng-content>
        </div>
        <a #opener (click)="open = !open" *ngIf="!hidden">
            <i [ngStyle]="{color: iconColor}" class="icon-more"></i>
        </a>
    </ng-container>
    <ng-container>
        <div *ngIf="open && !isTaskStatus" [@fade]="'in'" [class.bold]="bold" [ngStyle]="stylize"
             class="popup {{position}}">
            <a (click)="setAnswer(item.key); open = !open"
               *ngFor="let item of vars; let i = index"
               [attr.data-index-var]="i"
               data-action="setAnswer">
                <i [ngStyle]="{color: item.color}" class="{{item.icon ? item.icon : 'icon-minus'}}"></i>
                <span [attr.data-title-var]="item.title" [ngStyle]="{color: item.color}">{{ item.title }}</span>
            </a>
        </div>

        <div *ngIf="open && isTaskStatus" [@fade]="'in'" [class.bold]="bold" [ngStyle]="stylize"
             class="popup {{position}}">
            <a (click)="setAnswer(item.key); open = !open"
               *ngFor="let item of vars.availableOut; let i = index"
               [attr.data-index-var]="i"
               [class]="!item.canChange && item.is_successful ? 'blocked' : ''"
               data-action="setAnswer">
                <i [ngStyle]="{color: item.color}" class="{{item.icon ? item.icon : 'icon-minus'}}"></i>
                <span [ngStyle]="{color: item.color}" style="width: 100%">{{ item.title }}</span>
                <i *ngIf="item.is_successful"
                   class="bi bi-bookmark-check" style="color: blue; margin-left: 10px;"
                   title="{{ 'TASKS.DETAIL.TEXT.SUCCESS' | translate }}"></i>
                <i *ngIf="item.is_successful ? item.canChange : true" class="'bi bi-arrow-right"
                   title="{{ 'MODALS.BUTTONS.FORWARD' | translate }}"></i>
                <i *ngIf="!item.canChange && item.is_successful" class="bi bi-lock-fill text-danger"
                   title="{{ 'DENIED' | translate }}"></i>
            </a>

            <a (click)="isHideBackStatus = !isHideBackStatus" *ngIf="vars.availableIn.length"
               data-action="openBackStatuses"
               style="background: lightgrey">
                <span>{{ 'BUTTON_TEXT.CANCEL' | translate }}</span>
                <i *ngIf="isTaskStatus" class="icon-more" style="margin-left: 15px"></i>
            </a>

            <div *ngIf="!isHideBackStatus">
                <a (click)="setAnswer(item.key); open = !open"
                   *ngFor="let item of vars.availableIn; let ib = index"
                   [attr.data-index-var]="ib"
                   data-action="setAnswer">
                    <i *ngIf="isTaskStatus" class="bi bi-arrow-left"
                       title="{{ 'MODALS.BUTTONS.BACK' | translate }}"></i>
                    <i [ngStyle]="{color: item.color}" class="{{item.icon ? item.icon : 'icon-minus'}}"></i>
                    <span [ngStyle]="{color: item.color}" style="width: 100%">{{ item.title }}</span>
                </a>
            </div>
        </div>
    </ng-container>
    <div (click)="open = false" *ngIf="open" [class.open]="open" class="overflow" style="background: none"></div>
</div>
